import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import Loading from '../../../hoc/Loading/Loading';
import axios from '../../../axios';
import * as actionCreators from '../../../modules/actions/index';
import { connect } from 'react-redux';
import * as url from '../../../utils/url';
import {whiteLabelStyling,isUserRemoved,groupContentFields, 
  displayEventDates,grpBannerImg,
  groupPrivacyStatusDesc} from '../../../utils/constants';
import {toolkitCategories} from '../../../utils/categories';
import moment from 'moment';
import { Table, Modal, ModalBody, Button, ListGroupItem, Progress,DropdownMenu,DropdownToggle,Dropdown,Alert } from 'reactstrap';
import noResources from '../../../assets/onboarding/toolkit.png';
import loadingItems from '../../../assets/placeholders/kpi_available.svg';




class SingleEvent extends Component {
  constructor(props) {
    super(props);
    this.state = {   
      menu:'',
      event:{},
      dropdownOpen:false,
      isSuccess:false,
      removedItem:null,
      isLoaded:false
    }
  }


  componentDidMount() {
    let that=this 
    axios.post(url.getRecentEvent, {
        groupId: this.props.group._id, 
        category:"Conferences & Events",
        startDate:new Date()
    }).then((response) => {
      let event = response.data;
      that.setState({event, isLoaded:true})
    })
  } 

  viewTool=tool=>{
    let {category}=tool
    let tool_cat = toolkitCategories.filter(e=>e.name==category)[0]
    let tool_link = `/home/toolkit/${tool_cat.link}/tool/${tool._id}`
    this.props.history.push(tool_link);
  }

renderEvents = (event) => {
  const { orgAdmin } = this.props.user.profile;
  let{isSuccess,removedItem}=this.state, img_url

  if(event && event._id){
    img_url = event.bannerImg.url ? event.bannerImg.url: grpBannerImg 
  }
  

  return ( 
          <div className="grp_page_recent_event">
            <div className="grp_page_recent_event title">Upcoming Events</div> 
            {/* recently scheduled events */}
            { event && event._id ?
                <div className="">
                    <span  onClick={()=>this.viewTool(event)} className={'taskUploadPreviewImg'}>
                      <img src={img_url} className="fileUploadSize"/>
                        <div className="previewTaskImageText">
                            <span className="grp_desc grp_event_list_itm_date">
                                {displayEventDates(event, true, false, true)}
                              </span>
                            <span className="grp_desc previewTaskImageTitle">
                              {event.name}
                            </span>
                            <span className="grp_desc" >
                              {event.hasOwnProperty("subCategory")?event.subCategory: "No subcategory"}
                            </span> 
                            <div className="grp_desc grp_event_item_alt_color grp_event_list_itm_rsvp">
                              {event.interested_count} interested · {event.going_count} going
                            </div> 
                        </div>
                    </span>
                </div> :
                <span className="grp_desc">
                 There are currently no upcoming events.
                </span>
            }
            </div>
      //   </div>
      // </span> 
        )
};

goToEvents=()=>{
  this.props.history.push('/home/toolkit/conferences-events')
}
 

render() {
  let {  event, isLoaded  }=this.state

  return (<span className="">     
          {isLoaded!=true?
            <div className="grp_page_recent_event">   
              <span className="taskUploadPreviewImg">
                <img src={loadingItems} className="fileUploadSize"/> 
                <div className="grp_desc">Loading...</div>
              </span>
            </div>
            : 
                this.renderEvents(event)
                }
      </span>
    );
  }
}










const mapStateToProps = state => {
    return {
      user: state.user,
      kpiMaster: state.kpiMaster,
      mappingMaster: state.mappingMaster,
      reports:state.reports
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
      onKpiMasterListFetched: (data) => dispatch(actionCreators.storeKpiMaster(data)),
      onMappingMasterListFetched: (data) => dispatch(actionCreators.storeMappingMaster(data)),
      onProfileUpdate: (data) => dispatch(actionCreators.updateProfileInfoSuccess(data)),
      updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
      updateReport: (dashboard)=> dispatch(actionCreators.updateReport(dashboard)),
  
    }
  }


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Loading(SingleEvent, axios)));